import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

export const adminAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const isLoggedIn = localStorage.getItem('admin_logged_in') === 'true';

  if (isLoggedIn) {
    return true;
  }

  return router.createUrlTree(['/admin-panel/login']);
};